import { PageHeader } from '@atrvd/saas-ui'
import { FileImportSection } from '@/components/import/FileImportSection'
import { projectionImportConfig } from '@/components/import/import-configs'

/**
 * Projection Import Page
 * Provides CSV/XLSX file upload for bulk-importing projections.
 * Uses the generic FileImportSection with projection-specific configuration.
 */
export function ProjectionImportPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Projections Import"
        description="Import projections from CSV or Excel files"
      />

      <FileImportSection config={projectionImportConfig} />
    </div>
  )
}
